import DashboardHeader from "../components/dashboardheader/DashboardHeader";
import {
    Table,
    Breadcrumb,
    DatePicker,
    Button,
    Space,
    Modal,
    Typography
} from "antd";
import { useNavigate } from "react-router-dom";
import { ArrowLeftOutlined, CalendarOutlined, SearchOutlined } from "@ant-design/icons";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";
import { useContext, useEffect, useState } from "react";
import dayjs from "dayjs";

const { Title } = Typography;

export default function AttendanceLog() {
    const navigate = useNavigate();
    const { authData, backUrl } = useContext(AuthContext);
    const [data, setData] = useState(null);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    // 🔹 Fetch Data API
    const fetchData = async (start = fromDate, end = toDate) => {
        try {
            const res = await axios.get(
                `${backUrl}/api/hr/attendance/?from_date=${start}&to_date=${end}`,
                { headers: { Authorization: `Bearer ${authData.access}` } }
            );
            console.log("Attendance Data", res.data.results);
            setData(res.data.results);
            setIsModalOpen(false);
        } catch (err) {
            console.error("Error fetching attendance logs:", err);
        }
    };

    // 🔹 On Mount → Load current month data
    useEffect(() => {
        const firstDay = dayjs().startOf("month").format("YYYY-MM-DD");
        const lastDay = dayjs().endOf("month").format("YYYY-MM-DD");
        setFromDate(firstDay);
        setToDate(lastDay);
        fetchData(firstDay, lastDay);
    }, []);

    // Table columns
    const columns = [
        {
            title: "Date",
            dataIndex: "Attendance_Date",
            key: "Attendance_Date",
            render: (text) => {
                if (!text) return "-";
                return dayjs(text).format("DD/MM/YYYY");
            },
        },
        {
            title: "Check-in Time",
            dataIndex: "Check_in",
            key: "Check_in",
            render: (text) => (text ? text.slice(0, 5) : "-"),
        },
        {
            title: "Check-out Time",
            dataIndex: "Check_out",
            key: "Check_out",
            render: (text) => (text ? text.slice(0, 5) : "-"),
        },
        {
            title: "Punch In Time",
            dataIndex: "Punch_in",
            key: "Punch_in",
            render: (text) => (text ? text.slice(0, 5) : "-"),
        },
        {
            title: "Punch Out Time",
            dataIndex: "Punch_out",
            key: "Punch_out",
            render: (text) => (text ? text.slice(0, 5) : "-"),
        },
        {
            title: "Login Location",
            key: "Punch_In_Location",
            render: (_, record) => record.check_in_location_name || "-",
        },
        { title: "First In Type", dataIndex: "First_In_Type", key: "First_In_Type" },
        { title: "Last Out Type", dataIndex: "Last_Out_Type", key: "Last_Out_Type" },
    ];

    return (
        <>
            <DashboardHeader />

            {/* Breadcrumb */}
            <Breadcrumb style={{ margin: "16px 0 16px 50px", fontSize: 14 }}>
                <Breadcrumb.Item
                    onClick={() => navigate(-1)}
                    style={{ color: "#0e497b", cursor: "pointer", display: "flex", alignItems: "center", gap: 6 }}
                >
                    <ArrowLeftOutlined /> <a style={{ color: "#0e497b" }}>Back</a>
                </Breadcrumb.Item>
                <Breadcrumb.Item
                    onClick={() => setIsModalOpen(true)}
                    style={{ color: "#0e497b", cursor: "pointer", display: "flex", alignItems: "center", gap: 6 }}
                >
                    <a style={{ color: "#0e497b" }}>Fetch Attendance</a>
                </Breadcrumb.Item>
            </Breadcrumb>

            {/* Filter Modal */}
            <Modal
                title="Filter Attendance"
                open={isModalOpen}
                onCancel={() => setIsModalOpen(false)}
                footer={null}
                centered
            >
                <Space size="large" wrap style={{ width: "100%", justifyContent: "center" }}>
                    <DatePicker
                        placeholder="From Date"
                        value={fromDate ? dayjs(fromDate) : null}
                        onChange={(date, dateString) => setFromDate(dateString)}
                        prefixIcon={<CalendarOutlined />}
                        style={{ width: 180 }}
                    />

                    <DatePicker
                        placeholder="To Date"
                        value={toDate ? dayjs(toDate) : null}
                        onChange={(date, dateString) => setToDate(dateString)}
                        prefixIcon={<CalendarOutlined />}
                        style={{ width: 180 }}
                    />

                    <Button
                        type="primary"
                        icon={<SearchOutlined />}
                        onClick={() => fetchData(fromDate, toDate)}
                        style={{
                            backgroundColor: "#0e497b",
                            borderColor: "#0e497b",
                            borderRadius: "8px",
                            fontWeight: 500,
                        }}
                    >
                        Fetch Attendance
                    </Button>
                </Space>
            </Modal>

            {/* Table */}
            <div style={{ margin: "0 50px" }}>
                {data !== null && (
                    <Table
                        columns={columns}
                        dataSource={data}
                        rowKey="id"
                        pagination={{ pageSize: 10 }}
                        bordered
                        components={{
                            header: {
                                cell: (props) => (
                                    <th {...props} style={{ backgroundColor: "#0e497b", color: "white" }}>
                                        {props.children}
                                    </th>
                                ),
                            },
                        }}
                    />
                )}
            </div>
        </>
    );
}
